'use client';

import { useState, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import logger from '../util/logging.client';

/**
 * @name useRecaptchaV3
 * @description Function for using recaptcha for sweepr login
 * @param {object}  action - Name of action for analytics
 * @returns {object} Destructured object containing recpatchaV3 token and executeRecaptcha function
 */
export const useRecaptchaV3 = action => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [recaptchaV3Token, setRecaptchaV3Token] = useState(null);

  useEffect(() => {
    /**
     *@name handleReCaptchaVerify
     *@description - Function for verifying Recaptcha
     *@returns {string} -Verified Recaptcha token
     */
    const handleReCaptchaVerify = async () => {
      if (!executeRecaptcha) {
        return;
      }
      try {
        const useToken = await executeRecaptcha(action);
        setRecaptchaV3Token(useToken);
      } catch (error) {
        logger.log('error', 'Error executing recaptcha:', error);
      }
    };
    handleReCaptchaVerify();
  }, [executeRecaptcha, action]);

  return { recaptchaV3Token, executeRecaptcha };
};
